/* import __COLOCATED_TEMPLATE__ from './loading.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();